import { Paginated, Sortable } from "@ac-expo/api-types";

export type EventBadgesFilters = Sortable<
  Paginated<{
    searchText: string;
  }>
>;

export const badgesQueryKeys = {
  all: ["ticketing"] as const,
  event: (
    eventId: string,
    exhibitorId?: string,
    filters?: EventBadgesFilters
  ) => {
    const key: (string | EventBadgesFilters)[] = [
      ...badgesQueryKeys.all,
      "event",
      eventId,
    ];

    if (exhibitorId) key.push(exhibitorId);
    if (filters) key.push(filters);

    return key;
  },
  commercial: (eventId: string) =>
    [...badgesQueryKeys.all, "commercial", eventId] as const,
};

export const badgeTypesQueryKeys = {
  all: ["badges-types"] as const,
  event: (eventId: string) =>
    [...badgeTypesQueryKeys.all, "event", eventId] as const,
  get: (eventId: string, id: string) =>
    [...badgeTypesQueryKeys.all, "get", eventId, id] as const,
};

export default badgeTypesQueryKeys;
